import React, { useState } from 'react';
import { deleteMedicationList } from '../../Async/MedicationListsAsync';
import { Button, ButtonGroupStyle, ButtonMode, ButtonProps, ButtonSize, ButtonVariant } from '../../Components/Button';
import { DeleteDialog } from '../../Components/DeleteDialog/DeleteDialog';
import { TrashCanIcon } from '../../Components/Icons';
import { displayError, displayMessage } from '../../Config/ApplicationConfig';
import { MedicationListResponse } from '../../Contracts/MedicationList.Response';
import { MedicationLocale } from '../../Medications.en';
import { getFirstErrorMessageFromApiError, isDomainValidationError } from '../../Shared/DomainValidationFunctions';
import { iconLight } from '../../Styles/Colours';

export const DeleteMedicationListButton: React.FC<
    ButtonProps & {
        medicationList: MedicationListResponse;
        onDelete(): void;
    }
> = props => {
    const { medicationList, onDelete, ...buttonProps } = props;
    const [showDelete, setShowDelete] = useState(false);
    const [deleting, setDeleting] = useState(false);

    return (
        <>
            <Button
                {...buttonProps}
                testId={props.testId}
                size={ButtonSize.small}
                mode={ButtonMode.border}
                variant={ButtonVariant.danger}
                buttonGroup={ButtonGroupStyle.Right}
                startIcon={<TrashCanIcon noPadding size={'20'} color={iconLight} />}
                onClick={() => {
                    setShowDelete(true);
                }}
            >
                Delete
            </Button>
            {showDelete && (
                <DeleteDialog
                    title='Delete medication list'
                    testId='delete-medication-list'
                    disabled={deleting}
                    onCancel={() => {
                        setShowDelete(false);
                    }}
                    onOk={async () => {
                        setDeleting(true);
                        try {
                            await deleteMedicationList(medicationList.id);
                            displayMessage('Mediation list removed');
                            onDelete();
                        } catch (err) {
                            let errorMessage = 'Unable to remove medication list';
                            if (isDomainValidationError(err)) {
                                errorMessage = getFirstErrorMessageFromApiError(err, MedicationLocale);
                            }
                            displayError(errorMessage);
                            setDeleting(false);
                        }
                    }}
                >
                    Are you sure you want to remove {props.medicationList.name}?
                </DeleteDialog>
            )}
        </>
    );
};
